package io.horion.auth.presentation.ui.pages.logout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import io.horion.auth.di.koinGet
import io.horion.auth.presentation.ui.components.layouts.PageLayoutData
import io.horion.auth.presentation.ui.pages.navigation.Screen
import io.horion.auth.presentation.viewmodel.AuthViewModel
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initLogoutPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Logout Page"))
}

@OptIn(DelicateApi::class)
@Page("/logout")
@Composable
fun logoutPage() {
    val ctx = rememberPageContext()
    val authViewModel = koinGet<AuthViewModel>()

    val service = ctx.route.queryParams["service"]
    val redirect = ctx.route.queryParams["redirect"]
    val userUuid = ctx.route.queryParams["userUuid"]

    LaunchedEffect(ctx.route) {
        try {
            // 1. Exécuter la logique de déconnexion locale
            authViewModel.logoutLocal(service ?: "unknown",userUuid ?: "unknown")

            // 2. Redirection - toujours utiliser le routeur pour rester dans l'app
            if (redirect != null && !redirect.startsWith("/")) {
                // Si c'est une URL externe, utiliser window.location
                window.location.href = redirect
            } else {
                // Pour les routes internes, utiliser le routeur
                // Attendre un court instant pour permettre au routeur de se stabiliser
                delay(100)
                //ctx.router.navigateTo(redirect ?: "/")
            }
        } catch (e: Exception) {
            ctx.router.navigateTo(Screen.Login.route)
        }
    }
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Text("Déconnexion en cours...")
    }
}